function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _dec2, _dec3, _class;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { modalify, ZengularNotification } from "zengular-ui";
import { Brick } from "zengular";
import twig from "./profil.twig";
import service from "../modules/services/services";
import Alert from "./alert.brick";
import { Ajax } from "zengular-util";
import ZengularOverlay from "zengular-ui/bricks/zengular-overlay.brick";
import fileChooser from "../modules/file-chooser";
import "./profil.scss";
import Endpoints from "../modules/constants/end-points";
import Guard from "../modules/validation/guard";
import EmailValidator from "../modules/validation/validator/email-validator";
import AvailabilityValidator from "../modules/validation/validator/availability-validator";
import modalError from "../modules/birck-decorators/modal-error";
import errorMessages from "../modules/constants/error-messages";
var Profil = (_dec = modalify(), _dec2 = modalError(errorMessages), _dec3 = Brick.register('profil', twig), _dec(_class = _dec2(_class = _dec3(_class = /*#__PURE__*/function (_Brick) {
  _inherits(Profil, _Brick);

  var _super = _createSuper(Profil);

  function Profil() {
    _classCallCheck(this, Profil);

    return _super.apply(this, arguments);
  }

  _createClass(Profil, [{
    key: "onInitialize",
    value: function onInitialize() {}
  }, {
    key: "createViewModel",
    value: function createViewModel() {
      return {
        avatar: service.User.current.avatar
      };
    }
  }, {
    key: "onRender",
    value: function onRender() {
      var _this = this;

      this.$$('show').on.mouse.click(function (event, target) {
        _this.$$('show').each(function (node) {
          return node.classList.remove('primary');
        });

        target.classList.add('primary');

        _this.$('.toggle').each(function (node) {
          return node.classList.remove('active');
        });

        _this.$('.toggle.' + target.dataset.show).each(function (node) {
          return node.classList.add('active');
        });
      });
      this.$$('close').on.mouse.click(function () {
        return _this.close();
      });
      this.$$('avatar').on.mouse.click(function (event, target) {
        return _this.$$('file-chooser').node.click();
      });
      this.$$('file-chooser').on.input(function (event, target) {
        fileChooser(target, service.SiteData.config['avatar-max-filesize'], _this.$$('avatar').node).then(function (result) {
          if (result) {
            _this.$$('do-change-avatar').node.style.display = 'inline-block';
          } else {
            _this.$$('do-change-avatar').node.style.display = 'none';
          }
        });
      });
      this.$$('do-change-password').on.mouse.click(this.passwordChange.bind(this));
      this.$$('do-change-avatar').on.mouse.click(this.changeAvatar.bind(this));
      this.$$('do-change-email').on.mouse.click(this.changeEmail.bind(this));
      this.$$('do-suicide').on.mouse.click(this.suicide.bind(this));
    }
  }, {
    key: "passwordChange",
    value: function passwordChange() {
      var _this2 = this;

      Ajax.json(Endpoints.auth.password.request()).getJson.then(function (xhr) {
        _this2.close();

        Alert.modalify({
          icon: "fal fa-user",
          title: "Email kiküldve",
          content: "Kérlek kattints az e-mailben levő linkre!"
        });
      });
    }
  }, {
    key: "changeAvatar",
    value: function changeAvatar() {
      var _this3 = this;

      ZengularOverlay.show();
      Ajax.upload(Endpoints.user.avatar.upload(), null, [this.$$('file-chooser').node.files[0]]).get.then(function () {
        return new Promise(function (resolve) {
          return setTimeout(function () {
            return resolve();
          }, 1000);
        });
      }).finally(function () {
        ZengularOverlay.hide();

        _this3.close();

        _this3.wait(300).then(function () {
          return document.location.reload();
        });
      });
    }
  }, {
    key: "changeEmail",
    value: function changeEmail() {
      var _this4 = this;

      var guard = new Guard();
      guard.create('email').add(new EmailValidator().setMessage(function () {
        return 'A megadott email nem tűnik jónak...';
      })).add(new AvailabilityValidator(Endpoints.user.email.available()).setMessage(function () {
        return 'A megadott e-mail cím már foglalt!';
      }));
      var data = {
        email: this.$$('email').node.value,
        password: this.$$('password').node.value
      };
      ZengularOverlay.show();
      guard.test(data).catch(function (error) {
        return _this4.handleError(error);
      }).then(function () {
        return Ajax.json(Endpoints.user.email.change(), data).getJson;
      }).then(function (xhr) {
        return _this4.handleXhr(xhr);
      }).then(function () {
        return _this4.close();
      }).then(function () {
        return Alert.modalify({
          icon: "fal fa-user",
          title: "E-mail cím megváltoztatása",
          content: "Küldtünk neked egy e-mail-t...<br>Már csak pár kattintás!"
        });
      }).catch(function () {}).finally(function () {
        return ZengularOverlay.hide();
      });
    }
  }, {
    key: "suicide",
    value: function suicide() {
      var _this5 = this;

      Ajax.json(Endpoints.user.suicide(), {
        password: this.$$('suicide-password').node.value
      }).getJson.then(function (xhr) {
        return _this5.handleXhr(xhr);
      }).then(function () {
        return _this5.close();
      }).then(function () {
        return Alert.modalify({
          icon: "fas fa-skull-crossbones",
          title: "Felhasználó törlés",
          content: "Küldtünk neked egy e-mail-t...<br>Már csak pár kattintás!"
        });
      }).catch(function () {});
    }
  }]);

  return Profil;
}(Brick)) || _class) || _class) || _class);
export { Profil as default };